import { render, staticRenderFns } from "./InplayList2.vue?vue&type=template&id=c51c9518&scoped=true"
import script from "./InplayList2.vue?vue&type=script&lang=js"
export * from "./InplayList2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51c9518",
  null
  
)

export default component.exports